import { render } from "./invite_card.vue?vue&type=template&id=29c7f598"
import script from "./invite_card.vue?vue&type=script&lang=js"
export * from "./invite_card.vue?vue&type=script&lang=js"

import "./invite_card.vue?vue&type=style&index=0&id=29c7f598&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__